import { render, staticRenderFns } from "./ShiftEditForm.vue?vue&type=template&id=5f40fcaa&scoped=true&"
import script from "./ShiftEditForm.vue?vue&type=script&lang=js&"
export * from "./ShiftEditForm.vue?vue&type=script&lang=js&"
import style0 from "./ShiftEditForm.vue?vue&type=style&index=0&id=5f40fcaa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f40fcaa",
  null
  
)

export default component.exports